import { FieldRenderProps } from '@progress/kendo-react-form';

import styles from './TextFormField.module.scss';

interface IProps extends FieldRenderProps {
  href?: string;
  target?: string;
}

export const ExternalURLTextFormField = (fieldRenderProps: IProps) => {
  const { label, value, href, target } = fieldRenderProps;
  return (
    <div className='k-form-field'>
      <label htmlFor='#' className='k-label'>
        {label}
      </label>
      <div className='k-form-field-wrap'>
          {value ? <a className={`k-input-md k-rounded-md ${styles.field} ${value || href ? styles.link : styles.emptyLink}`}
                      href={href || value} target={target}>
              {value}
          </a> : <span>N/A</span>}
      </div>
    </div>
  );
};
